<template>
    <div id="J_load_more" class="loading">
        <p class="txt">没有更多数据了~</p>
    </div>
</template>

<script>

	export default {
	  	data() {
		    return {

		    }
	  	},    
        mounted(){
            // console.log(this.tabTitle)
        },
        methods: {

        }
	}
</script>
<style>    
    .loading {
        padding: 0.1rem 0;
        background-color: #f9f9f9;
        /*display: none*/
    }

    .loading .txt {
        font-size: 0.22rem;
        padding: 0.1rem 0;
        text-align: center;
        color: #b3b3b3;
    }
</style>




// WEBPACK FOOTER //
// src/components/loadingNoMore.vue